import styled from 'styled-components';

export const FooterContainer = styled.footer`
    background-color: #010606;
    padding: 2rem 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const FooterContent = styled.div`
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

export const FooterLinks = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    margin-bottom: 1rem;

    @media screen and (max-width: 480px) {
        flex-direction: column;
        gap: 1rem;
    }
`;

export const FooterLink = styled.a`
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.2s ease-in-out;

    &:hover {
        color: #01bf71;
    }
`;

export const Copyright = styled.p`
    color: #fff;
    font-size: 14px;
    text-align: center;
`; 